import React from "react";
import PropTypes from 'prop-types';
import {observer, inject} from 'mobx-react';
import classnames from 'classnames';

import {Svg} from "../../../components/svg";
import {ChecklistItem, BUTTON_TYPES} from "./checklist-item";

import copy from './copy.json';


export const LicenseVerificationChecklistItem = inject('completeMyPaperworkStore', 'historyStore')(
    observer(
        class _LicenseVerificationChecklistItem extends React.Component {
            static propTypes = {
                historyStore: PropTypes.shape({
                    history: PropTypes.shape({
                        push: PropTypes.func.isRequired
                    }),
                }).isRequired,
                completeMyPaperworkStore: PropTypes.shape({
                    hasSubmittedLicenseVerification: PropTypes.bool.isRequired,
                    isLicenseVerificationRequired: PropTypes.bool.isRequired,
                    isLicenseVerificationAccepted: PropTypes.bool.isRequired,
                    isLicenseVerificationComplete: PropTypes.bool.isRequired,
                    getPaperworkUrl: PropTypes.func.isRequired,
                }).isRequired,
                isBrpFinancialTheme: PropTypes.bool,
            };

            copy = copy.license_verification;

            getSubText() {
                const {completeMyPaperworkStore} = this.props;

                if (!completeMyPaperworkStore.hasSubmittedLicenseVerification) {
                    return null;
                }
                if (!completeMyPaperworkStore.isLicenseVerificationComplete) {
                    return this.copy.processing_text;
                }
                if (!completeMyPaperworkStore.isLicenseVerificationAccepted) {
                    return this.copy.rejected_text;
                }
                return null;
            }

            getButtonType() {
                const {completeMyPaperworkStore} = this.props;
                if (completeMyPaperworkStore.isLicenseVerificationAccepted) {
                    return BUTTON_TYPES.DONE;
                }
                if (completeMyPaperworkStore.isLicenseVerificationComplete) {
                    return BUTTON_TYPES.RESUBMIT;
                }
                return BUTTON_TYPES.SUBMIT_DOCS;
            }

            goToLicenseVerification = () => {
                let cmpStore = this.props.completeMyPaperworkStore;
                let applicantUuid = cmpStore[`${cmpStore.prefix}Uuid`];
                this.props.historyStore.history.push(
                    cmpStore.getPaperworkUrl('/license-verification', applicantUuid)
                );
            };

            render() {
                const {
                    isLicenseVerificationRequired,
                    isLicenseVerificationAccepted,
                } = this.props.completeMyPaperworkStore;
                const checklistItemProps = {
                    title: this.copy.title,
                    buttonType: this.getButtonType(),
                    isBrpFinancialTheme: this.props.isBrpFinancialTheme,
                };

                if (!isLicenseVerificationRequired) {
                    return null;
                }

                if (!isLicenseVerificationAccepted) {
                    checklistItemProps.onClickButton = this.goToLicenseVerification;
                }

                const subText = this.getSubText();
                return (
                    <ChecklistItem {...checklistItemProps}>
                        {subText && (
                            <div className="border-top border-secondary mt-3 pt-2">
                                <Svg className={classnames("mr-2", this.props.isBrpFinancialTheme ? "spark-text-primary" : "spark-text-note")} svg="processing-icon"/>
                                <span className="spark-text-14px-bold">
                                    {subText}
                                </span>
                            </div>
                        )}
                    </ChecklistItem>
                );
            }
        }
    )
);
